<template>
  <nav class="panel panel--east-search-header">
    <div class="panel-block">
      <p class="control has-icon" :class="{ 'is-search-active': !_isNil(search) && search !== '' }">
        <input
          v-model="search"
          class="input is-small"
          type="text"
          :placeholder="$t('label.search')"
          @keyup.enter="handleSearch">
        <span class="icon is-small" @click="handleSearch">
          <i class="fa fa-search"></i>
        </span>
        <button
          v-if="haveSearch"
          @click="handleClear"
          class="button is-warning">
          {{ $t('label.clear') }}
        </button>
      </p>
    </div>
    <div class="panel-tabs panel-search-filter">
      <el-select
         v-model="filterSelected"
         popper-class="el-select-dropdown--east-search-filter"
        :multiple="true"
        :placeholder="$t('label.filter_by_origin')"
        @change="handleFilterByOrigin">
        <el-option-group
           v-for="(group, key) in filters.list"
          :label="group.label"
          :key="group.key">
            <el-option
               v-for="item in group.options"
              :label="group.label + ': ' + item.label"
              :value="`${group.key},${item.key}`"
              :key="item.key">
              <span style="float: left">{{ item.label }}</span>
            </el-option>
        </el-option-group>
      </el-select>
    </div>
  </nav>
</template>

<script>
import Vue from 'vue';
import { isEmpty, get, clone, each, difference, find, findIndex, join } from 'lodash';

export default {
  name: 'east-search-filter',
  componentName: 'EastSearchFilter',
  props: {
    filters: {
      type: Object,
      required: true,
      default() { return {}; },
    },
  },
  data() {
    return {
      search: null,
      searched: null,
      filterSelected: [],
      filterGroups: {},
      copySelected: [],
    };
  },
  computed: {
    haveSearch() {
      return this.searched;
    },
  },
  methods: {
    handleFilterByOrigin(value) {
      const diff = difference(value, this.copySelected);
      if (!isEmpty(diff)) {
        const tmp = diff[0].split(',');
        const found = find(this.copySelected, item => item.startsWith(tmp[0]));
        if (found) {
          const removeAtPosition = findIndex(this.filterSelected, item => item === found);
          this.filterSelected.splice(removeAtPosition, 1);
        }
        this.copySelected = clone(value);
      }
      const filterQuery = this.getFilterQuery();
      this.$emit('filterByOrigin', filterQuery);
    },
    getFilterQuery() {
      const query = [];
      each(this.filterSelected, (filter) => {
        const tmp = filter.split(',');
        query.push(tmp[1]);
      });
      return join(query, ',');
    },
    handleSearch() {
      this.searched = clone(this.search);
      this.$emit('search', this.search);
    },
    handleClear() {
      this.search = '';
      this.searched = null;
      this.$emit('search', '');
    },
    reset() {
      this.search = null;
      this.searched = null;
      this.filterSelected = [];
      this.filterGroups = {};
      this.copySelected = [];
    },
  },
  created() {
    this.filterSelected = get(this.filters, 'selected.key', []);
    this.copySelected = clone(this.filterSelected);
    // this.search = get(this.filters, 'search.0', null);
    each(this.filters.list, (group) => {
      Vue.set(this.filterGroups, group.key, null);
    });
  },
  beforeDestroy() {
    this.reset();
  },
};
</script>

<style lang="scss">
  .panel--east-search-header {
    border: none;
    .panel-block, .panel-tabs {
      border-left: none;
      border-right: none;
      &:first-child {
        border-top: none;
      }
    }
    .panel-search-filter {
      .el-select {
        width: 100%;
        .el-input__inner {
          background-color: inherit;
          border: none;
          border-radius: 0;
          padding: 0.5em 1em;
        }
        .el-input__icon {
          right: 0.25em;
        }
      }
    }
    .control {
      position: relative;
      .input.is-small {
        font-size: 0.85rem;
        border-radius: 5px;
        border: 2px solid #dbdbdb;
        &:focus {
          border-color: #ffdd57;
        }
      }

      .icon.is-small {
        pointer-events: auto;
        &:hover {
          cursor: pointer;
        }
      }


      &.is-search-active {
        .input {
          border-color: #ffdd57;
        }
      }

      .button {
        top: 4px;
        z-index: 4;
        right: 4px;
        height: 1.85em;
        line-height: 1;
        position: absolute;
        font-size: 0.75rem;
      }
    }
  }
  .el-select-dropdown--east-search-filter {
    margin: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/search/east-search-filter.vue